import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Truck, Mail, Menu, X } from "lucide-react";

const navItems = [
  { to: "/", label: "Forside", id: "home" },
  { to: "/ydelser", label: "Ydelser", id: "services" },
  { to: "/om-os", label: "Om os", id: "about" },
  { to: "/kontakt", label: "Kontakt", id: "contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 w-full border-b border-slate-200 bg-white/85 backdrop-blur-xl"
    >
      {/* Top bar with email */}
      <div className="hidden md:block border-b border-slate-100 bg-slate-50">
        <div className="mx-auto flex max-w-7xl items-center justify-end gap-2 px-6 py-2 text-sm">
          <Mail className="h-4 w-4 text-brand" />
          <span className="text-slate-500">Skriv til os:</span>
          <a
            data-testid="header-email-link"
            href="mailto:info@sb-logistik.dk"
            className="font-semibold text-slate-800 transition-colors hover:text-brand"
          >
            info@sb-logistik.dk
          </a>
        </div>
      </div>

      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <Link
          data-testid="logo-link"
          to="/"
          className="flex items-center gap-2.5"
          onClick={() => setOpen(false)}
        >
          <span className="flex h-10 w-10 items-center justify-center rounded-sm bg-brand text-white">
            <Truck className="h-6 w-6" />
          </span>
          <span className="font-heading text-xl font-bold tracking-tight text-slate-900">
            SB Logistik
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden items-center gap-8 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.id}
              data-testid={`nav-${item.id}-link`}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors hover:text-brand ${
                  isActive ? "text-brand" : "text-slate-600"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            data-testid="header-cta-button"
            to="/kontakt"
            className="rounded-sm bg-brand px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-brand-hover"
          >
            Kontakt os
          </Link>
        </nav>

        {/* Mobile toggle */}
        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-slate-800"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {/* Mobile nav */}
      {open && (
        <div data-testid="mobile-menu" className="border-t border-slate-200 bg-white md:hidden">
          <nav className="flex flex-col px-6 py-4">
            {navItems.map((item) => (
              <NavLink
                key={item.id}
                data-testid={`mobile-nav-${item.id}-link`}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `border-b border-slate-100 py-3 text-base font-medium ${
                    isActive ? "text-brand" : "text-slate-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <a
              data-testid="mobile-header-email-link"
              href="mailto:info@sb-logistik.dk"
              className="flex items-center gap-2 py-3 font-semibold text-brand"
            >
              <Mail className="h-4 w-4" /> info@sb-logistik.dk
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
